import { render, staticRenderFns } from "./ReportSummary.vue?vue&type=template&id=726c2172&scoped=true&"
import script from "./ReportSummary.vue?vue&type=script&lang=js&"
export * from "./ReportSummary.vue?vue&type=script&lang=js&"
import style0 from "./ReportSummary.vue?vue&type=style&index=0&id=726c2172&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726c2172",
  null
  
)

export default component.exports